//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import { language } from "../language/Leavelist.js";
import html2pdf from "html2pdf.js";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";
import PrintReceiptDejTab from "./PrintReceiptDejTab";
import PrintReceiptStandardTab from "./PrintReceiptStandardTab";
import PrintReceiptDetailDejTab from "./PrintReceiptDetailDejTab";
import PrintReceiptDetailStandardTab from "./PrintReceiptDetailStandardTab";

var convert = require("decimal-number-to-words");

import unity from "@/unity/unity";

import { generateReceiptPDF } from "@/utils/pdfReceiptGenerator";

import {
  generateReceiptDetailPDF,
  downloadReceiptDetailPDF,
  printReceiptDetailPDF,
} from "@/utils/pdfReceiptDetailGenerator";

export default {
  name: "invoice",
  data(vm) {
    return {
      pdfMakeReady: false,
      mockData: {
        main_data: null, // จะโยนค่าเข้ามาตอนเรียกใช้
        main_data_detail: null, // เพิ่มบรรทัดนี้สำหรับ Detail Receipt
      },

      dialogSelectClientInfoReceipt: "primary",

      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      getcompany_id: localStorage.getItem(server.COMPANYID),
      main_customer_id: 0,
      desserts: [],
      mDataArrayforinv: [],
      inv_subtotal: 0,
      wth_ratetotal: 0,
      tax_ratetotal: 0,
      amount_total: 0,
      wth_rate: 0,
      check_cus_name: false,
      company_search: "",
      department_search: 0,
      department_list: [],
      company_list: [
        {
          company_name: "บริษัท เดชอุดม จำกัด",
          company_code: "D",
        },
        {
          company_name: "สำนักงานทนายความ",
          company_code: "L",
        },
      ],
      bank_name_show: "",
      bank_no_show: "",
      curency_show_tb: "",
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      search_status: "",
      status_search: ["Draft", "Submit"],
      dialogAddS: false,
      dialogAdd: false,
      tax_rate: 0,
      dialogAddData: "1",
      dialogSelect: "1",
      exchange_rate: 1,
      vat_type: "",
      menu: false,
      menu2: false,
      search: "",
      currency_print: "",
      currency_show: "",
      toggleEnable: false,
      dialogSelectPrint: false,
      dataAll: [],
      datefrom: null,
      dateto: null,
      seticonsearchmore: { icon: "mdi mdi-chevron-down", action: false },
      setlanguage: language.en,
      mDataArray: [],
      authorize: [],
      headers: [
        {
          text: "Receive No.",
          value: "trc_id",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Doc Date",
          value: "date_show",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Client Name",
          value: "cus_name",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Amount",
          value: "trc_sub_amoumt_s",
          class: "bg-colorth tabletextwhite",
          align: "end",
        },
        {
          text: "Currency",
          value: "currency",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Status",
          value: "status",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Print",
          value: "actions",
          class: "bg-colorth tabletextwhite",
          sortable: false,
        },
      ],
      payment_by_print: "",
      main_id_print: 0,
      inv_id: 0,
      inv_detail_id: 0,
      tax_detail_rate: 0,
      vat: 0,
      showprint: "",
      showprintDetail: "",
      textamount_total_en: "",
      setlanguage: language.en,
      print_header_list: [
        {
          id: "1",
          com_title: "RECEIPT / TAX INVOICE",
          com_title_th: "ใบเสร็จรับเงิน / ใบกำกับภาษี",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
        },
        {
          id: "2",
          com_title: "RECEIPT",
          com_title_th: "ใบเสร็จรับเงิน",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
        },
      ],

      print_header_list_detail: [
        {
          id: "1",
          com_title: "RECEIPT / TAX INVOICE",
          com_title_th: "ใบเสร็จรับเงิน / ใบกำกับภาษี",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
        },
        {
          id: "2",
          com_title: "RECEIPT",
          com_title_th: "ใบเสร็จรับเงิน",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
        },
      ],
      print_header: null,
      print_detail_header: null,
      print_table_detail: [],
      print_table_Rcdetail: [],
      pageAll: 1,
      pageAllDetail: 1,
      opensummarize: false,
      opensummarizeDetail: false,
      datashowAll: [],
      datashowAllDetail: [],
      dataforshowprpo: [],
      setdatatoshow: [],
      setdatatoshowDetail: [],
      branch_cus: "",
      checklawoffice: false,
      heighttabledetail: "0px",
    };
  },
  components: {
    SuccessDialog,
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async created() {},
  beforeUpdate() {},
  components: {
    PrintReceiptDejTab,
    PrintReceiptStandardTab,
    PrintReceiptDetailDejTab,
    PrintReceiptDetailStandardTab,
  },
  computed: {
    computeddatefromFormatted() {
      return unity.formatDate(this.datefrom);
    },
    computeddateToFormatted() {
      return unity.formatDate(this.dateto);
    },
    itemsForSelected() {
      if (this.search.length) {
        return this.dataSource.filter((item) => this.search.includes(item));
      }
      return this.dataSource;
    },

    dataToUse() {
      return this.mockData.main_data || {};
    },

    header() {
      return this.dataToUse.print_header || {};
    },

    items() {
      const datashowAll = this.dataToUse.datashowAll || [];
      const allItems = [];

      datashowAll.forEach((group) => {
        if (Array.isArray(group)) {
          group.forEach((item) => {
            allItems.push(item);
          });
        }
      });

      return allItems;
    },

    currencyPrint() {
      return this.dataToUse.currency_print || "";
    },

    exchangeRate() {
      return this.dataToUse.exchange_rate || "";
    },

    showCurrencyColumn() {
      const curr = this.currencyPrint.toUpperCase();
      return curr === "US" || curr === "USD";
    },

    dataToUseDetail() {
      return this.mockData.main_data_detail || {};
    },

    headerDetail() {
      return this.dataToUseDetail.print_header || {};
    },

    itemsDetail() {
      const datashowAllDetail = this.dataToUseDetail.datashowAllDetail || [];
      const allItems = [];

      datashowAllDetail.forEach((group) => {
        if (Array.isArray(group)) {
          group.forEach((item) => {
            allItems.push(item);
          });
        }
      });

      return allItems;
    },

    currencyPrintDetail() {
      return this.dataToUseDetail.currency_print || "";
    },

    exchangeRateDetail() {
      return this.dataToUseDetail.exchange_rate || "";
    },
  },
  async mounted() {
    await api.checkVersion();
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center",
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    let comp_id = localStorage.getItem(server.COMPANYID);

    this.userId = localStorage.getItem(server.USER_ID);
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    // await this.loaddata();
    await this.loadDepartmentByCompanyId();

    this.waitForPdfMakeReady()
      .then(() => {
        this.pdfMakeReady = true;
        console.log("✅ pdfMake พร้อมใช้งาน");
      })
      .catch((error) => {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("ไม่สามารถโหลด pdfMake ได้ กรุณาลองใหม่อีกครั้ง");
      });

    this.$hideLoader();
  },
  methods: {
    // 1. เพิ่มฟังก์ชัน findAllByAPISearch
    async findAllByAPISearch() {
      await this.onSearchPagination();
    },

    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddataPagination() {
      var tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.tableLoading = true;

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id
     */

      try {
        const result = await api.getDataReceiveHQ_Pagination_V2(
          1,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          this.company_search,
          this.department_search,
          this.search_status,
          this.datefrom ? this.datefrom : null,
          this.dateto ? this.dateto : null,
          this.search ? this.search : null,
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.dataAll2.forEach((item) => {
          item.trc_sub_amoumt_s = tolocalestringnumber(
            Number(item.trc_sub_amoumt),
          );
          if (!item.trc_id) {
            item.trc_id = "####";
          }
        });

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "DESC";
      } else {
        sortDesc = "ASC";
      }

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id
     */

      try {
        const result = await api.getDataReceiveHQ_Pagination_V2(
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          localStorage.getItem(server.COMPANYID),
          this.company_search,
          this.department_search,
          this.search_status,
          this.datefrom ? this.datefrom : null,
          this.dateto ? this.dateto : null,
          this.search ? this.search : null,
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.dataAll2.forEach((item) => {
          item.trc_sub_amoumt_s = tolocalestringnumber(
            Number(item.trc_sub_amoumt),
          );
          if (!item.trc_id) {
            item.trc_id = "####";
          }
        });

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];

      /*
          page,
        limit,
        sortBy,
        sortOrder,
        company_id
     */

      try {
        const result = await api.getDataReceiveHQ_Pagination_V2(
          pageNumber,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          this.company_search,
          this.department_search,
          this.search_status,
          this.datefrom ? this.datefrom : null,
          this.dateto ? this.dateto : null,
          this.search ? this.search : null,
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.dataAll2.forEach((item) => {
          item.trc_sub_amoumt_s = tolocalestringnumber(
            Number(item.trc_sub_amoumt),
          );
          if (!item.trc_id) {
            item.trc_id = "####";
          }
        });

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.tableLoading = true;

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id
     */

      // var s_data = {
      //   page: 1,
      //   limit: this.itemsPerPage,
      //   sortBy: "id",
      //   sortOrder: "ASC",
      //   company_id: localStorage.getItem(server.COMPANYID),
      // };

      try {
        const result = await api.getDataReceiveHQ_Pagination_V2(
          1,
          this.itemsPerPage,
          "id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          this.company_search,
          this.department_search,
          this.search_status,
          this.datefrom ? this.datefrom : null,
          this.dateto ? this.dateto : null,
          this.search ? this.search : null,
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.dataAll2.forEach((item) => {
          item.trc_sub_amoumt_s = tolocalestringnumber(
            Number(item.trc_sub_amoumt),
          );
          if (!item.trc_id) {
            item.trc_id = "####";
          }
        });

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.recordsPerPage;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    async loadDepartmentByCompanyId() {
      let result = await api.getAllDepartment_By_CompanyID(
        localStorage.getItem(server.COMPANYID),
      );
      this.department_list = result.data;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAddS = status;
      this.text_color = text_color;
    },
    showsearchmore() {
      this.toggleEnable = !this.toggleEnable;
      this.seticonsearchmore.action = !this.seticonsearchmore.action;
      if (this.seticonsearchmore.action === true) {
        this.seticonsearchmore.icon = "mdi mdi-chevron-up";
      } else {
        this.seticonsearchmore.icon = "mdi mdi-chevron-down";
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month - 1}-${day}`;
    },
    findChaege() {
      let data_s = [];
      data_s = this.dataAll2;
      if (this.company_search != "") {
        // alert("com")
        data_s = data_s.filter((item) => {
          if (item.company_trc == this.company_search) {
            return item;
          }
        });
      }
      if (this.department_search != 0) {
        // alert("dept")
        data_s = data_s.filter((item) => {
          if (item.dep_id == this.department_search) {
            return item;
          }
        });
      }
      if (this.search_status != "") {
        // alert("status")
        data_s = data_s.filter((item) => {
          if (item.status == this.search_status) {
            return item;
          }
        });
      }

      if (this.datefrom != null && this.dateto != null) {
        // alert("date")
        data_s = data_s.filter((item) => {
          if (item.date >= this.datefrom && item.date <= this.dateto) {
            return item;
          }
        });
      }

      // console.log(`search: ${this.search}`);

      // เพิ่มการค้นหาด้วย search text
      if (this.search != "" && this.search != null) {
        data_s = data_s.filter((item) => {
          const searchTerm = this.search.toLowerCase();
          return (
            (item.trc_id && item.trc_id.toLowerCase().includes(searchTerm)) ||
            (item.cus_name &&
              item.cus_name.toLowerCase().includes(searchTerm)) ||
            (item.inv_id && item.inv_id.toLowerCase().includes(searchTerm)) ||
            (item.pinv_id && item.pinv_id.toLowerCase().includes(searchTerm))
          );
        });
        // console.log(`filtered by search: ${data_s.length}`); // Debug log
        // console.log(`data_s: ${JSON.stringify(data_s)}`); // Debug log
      }

      if (
        this.company_search == "" &&
        this.department_search == 0 &&
        this.search_status == "" &&
        this.datefrom == null &&
        this.dateto == null &&
        (this.search == "" || this.search == null)
      ) {
        data_s = this.dataAll2;
      }

      this.mDataArray2 = data_s;
    },

    async loaddata() {
      const result = await api.getDataReceiveHQ(
        Number(localStorage.getItem(server.COMPANYID)),
      );
      this.dataAll = result.data;
      this.dataAll.forEach((item) => {
        item.trc_sub_amoumt_s = tolocalestringnumber(
          Number(item.trc_sub_amoumt),
        );
        if (!item.trc_id) {
          item.trc_id = "####";
        }
      });

      this.mDataArray = result.data;

      this.$hideLoader();
    },
    OpenDialog(item_id) {
      if (
        localStorage.getItem(server.COMPANYID) == "1" ||
        localStorage.getItem(server.COMPANYID) == 1
      ) {
        this.dialogAdd = true;
      } else {
        this.$router.push(
          `/receive-select-document/${localStorage.getItem(server.COMPANYID)}`,
        );
      }
    },
    async toInvCNforRecrive() {
      let company_inv = "";
      if (this.dialogAddData == "1") {
        company_inv = "D";
      } else if (this.dialogAddData == "2") {
        company_inv = "L";
      } else {
      }
      this.$router.push(`/receive-select-document/${company_inv}`);
    },
    async onClicktoeditRC(id) {
      this.$router.push(`/receive-edit/${id}`);
    },
    async onClicktoPrint(data) {
      if (data.currency_print == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check information",
          "Fail  Currency Null Data",
          "text-h5 red--text text-center",
        );
        return;
      }
      this.main_customer_id = data.customer_id;
      this.main_id_print = data.id;
      this.currency_print = data.currency;
      this.vat = data.tax_rate;
      this.exchange_rate = data.exchange_rate;
      await this.loadinv_handcal();
      await this.loadCustomer();
      await this.SumDataT();
      this.dialogSelectPrint = true;
    },
    async loadRef_TypeRcById() {
      this.print_header = {};
      const res_inv_id = await api.getDataReceiveDByIDOne(this.main_id_print);

      this.inv_id = res_inv_id.data[0].inv_hid;
      this.tax_rate = res_inv_id.data[0].tax_rate;
      this.payment_by_print = res_inv_id.data[0].payment_by;
      this.bank_name_show = res_inv_id.data[0].bank_name;
      this.bank_no_show = res_inv_id.data[0].bank_no;
      // const res_hresult = await api.getdataByIdInvoice_HRC(
      //   res_inv_id.data[0].inv_hid
      // );

      const res_hresult = await api.getPrintDataByIdAndCusTypeInvoice_HRC(
        res_inv_id.data[0].inv_hid,
        this.dialogSelectClientInfoReceipt,
      );

      if (res_hresult.data[0].company_inv == "D") {
        this.getcompany_id = 1;
        this.print_header = this.print_header_list[0];
        this.checklawoffice = false;
        this.heighttabledetail = "270px";
        this.print_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
      } else if (res_hresult.data[0].company_inv == "L") {
        this.getcompany_id = 1;
        this.print_header = this.print_header_list[1];
        this.checklawoffice = true;
        this.heighttabledetail = "300px";
        this.print_header.com_title = "RECEIPT";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน";
      } else {
        this.getcompany_id = res_hresult.data[0].company_inv;
        this.heighttabledetail = "365px";
        this.print_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
        this.print_header.com_name = res_hresult.data[0].com_name;
        this.print_header.inv_company_address =
          res_hresult.data[0].inv_company_address;
        this.print_header.inv_company_branch =
          res_hresult.data[0].inv_company_branch;
        this.print_header.inv_company_tel = res_hresult.data[0].inv_company_tel;
        this.print_header.inv_company_email =
          res_hresult.data[0].inv_company_email;
        this.print_header.inv_tax_id = res_hresult.data[0].inv_tax_id;
        this.print_header.inv_company_name_th =
          res_hresult.data[0].inv_company_name_th;
      }

      if (res_inv_id.data[0].payment_by == "cash") {
        this.print_header.payment_by = "Cash";
      } else if (res_inv_id.data[0].payment_by == "Bank") {
        this.print_header.payment_by = "Transfer";
      } else if (res_inv_id.data[0].payment_by == "cheque") {
        this.print_header.payment_by = "Cheque";
      } else {
        this.print_header.payment_by = "Other";
      }
      // this.wth_rate = res_hresult.data[0].wth_rate;
      this.print_header.payment_detail = res_inv_id.data[0].payment_comment;
      this.print_header.inv_id = res_inv_id.data[0].trc_id;

      this.print_header.invoice_date = res_hresult.data[0].date_show;

      this.print_header.wth_rate = res_hresult.data[0].wth_rate;
      this.print_header.tax_rate = this.tax_rate;
      this.print_header.wth_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].wth_rate) / 100,
      );
    },
    async loadRef_TypeRcDetailById() {
      this.print_detail_header = {};
      const res_inv_id = await api.getDataReceiveDByIDOne(this.main_id_print);

      this.inv_detail_id = res_inv_id.data[0].inv_hid;
      this.tax_detail_rate = res_inv_id.data[0].tax_rate;
      this.payment_by_print = res_inv_id.data[0].payment_by;
      this.bank_name_show = res_inv_id.data[0].bank_name;
      this.bank_no_show = res_inv_id.data[0].bank_no;
      let inv_no = "";
      res_inv_id.data.forEach((item, index) => {
        if (index < res_inv_id.data.length - 1) {
          inv_no = inv_no + item.inv_id + ", ";
        } else {
          inv_no = inv_no + item.inv_id;
        }
      });

      // const res_hresult = await api.getdataByIdInvoice_HRC(
      //   res_inv_id.data[0].inv_hid
      // );

      const res_hresult = await api.getPrintDataByIdAndCusTypeInvoice_HRC(
        res_inv_id.data[0].inv_hid,
        this.dialogSelectClientInfoReceipt,
      );

      if (res_hresult.data[0].company_inv == "D") {
        this.getcompany_id = 1;
        this.print_detail_header = this.print_header_list_detail[0];
        this.checklawoffice = false;
        this.heighttabledetail = "270px";
        this.print_detail_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
      } else if (res_hresult.data[0].company_inv == "L") {
        this.getcompany_id = 1;
        this.print_detail_header = this.print_header_list_detail[1];
        this.checklawoffice = true;
        this.heighttabledetail = "300px";
        this.print_detail_header.com_title = "RECEIPT";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน";
      } else {
        this.getcompany_id = res_hresult.data[0].company_inv;
        this.heighttabledetail = "365px";
        this.print_detail_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
        this.print_detail_header.com_name = res_hresult.data[0].com_name;
        this.print_detail_header.inv_company_address =
          res_hresult.data[0].inv_company_address;
        this.print_detail_header.inv_company_branch =
          res_hresult.data[0].inv_company_branch;
        this.print_detail_header.inv_company_tel =
          res_hresult.data[0].inv_company_tel;
        this.print_detail_header.inv_company_email =
          res_hresult.data[0].inv_company_email;
        this.print_detail_header.inv_tax_id = res_hresult.data[0].inv_tax_id;
        this.print_detail_header.inv_company_name_th =
          res_hresult.data[0].inv_company_name_th;
      }

      this.print_detail_header.invoice_no = inv_no;
      if (res_inv_id.data[0].payment_by == "cash") {
        this.print_detail_header.payment_by = "Cash";
      } else if (res_inv_id.data[0].payment_by == "Bank") {
        this.print_detail_header.payment_by = "Transfer";
      } else if (res_inv_id.data[0].payment_by == "cheque") {
        this.print_detail_header.payment_by = "Cheque";
      } else {
        this.print_detail_header.payment_by = "Other";
      }
      // this.wth_rate = res_hresult.data[0].wth_rate;
      this.print_detail_header.payment_detail =
        res_inv_id.data[0].payment_comment;
      this.print_detail_header.inv_id = res_inv_id.data[0].trc_id;

      this.print_detail_header.invoice_date = res_hresult.data[0].date_show;

      this.print_detail_header.wth_rate = res_hresult.data[0].wth_rate;
      this.print_detail_header.tax_rate = this.vat;
      this.print_detail_header.wth_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].wth_rate) / 100,
      );
    },
    async loadInvSoData() {
      //data in table
      var tmp_inv_data;
      var sub_total = 0;

      const res_inv_rc = await api.getDataPrint(this.main_id_print);

      tmp_inv_data = res_inv_rc.data;

      tmp_inv_data.forEach((item, index) => {
        var data = {
          no: 0,
          inv_id: "",
          date: null,
          credit_term: 0,
          currency: "",
          amount: 0,
        };

        data.no = index + 1;
        data.inv_id = item.inv_id;
        data.date = item.date_show;
        data.credit_term = item.credit_term;
        data.currency = item.currency;

        data.amount = Number(item.Amount);
        if (this.vat_type == "E") {
          data.amount_s = Number(item.Amount);
        } else if (this.vat_type == "I") {
          data.amount_s = Number(item.Amount);
        } else {
          return;
        }
        data.amount_s = parseFloat(data.amount_s);
        this.print_table_detail.push(data);
        sub_total = Number(sub_total) + Number(data.amount);
      });
      sub_total = sub_total.toFixed(2);

      if (this.vat_type == "E") {
        this.print_header.sub_total = parseFloat(Number(sub_total).toFixed(2));
        this.print_header.tax_rate_amount = parseFloat(
          Number((this.print_header.sub_total * this.vat) / 100).toFixed(2),
        );
        this.print_header.amount_total = parseFloat(
          Number(this.print_header.sub_total) +
            Number(this.print_header.tax_rate_amount),
        );
        console.log(
          "this.print_header.sub_total: " + this.print_header.sub_total,
        );
        console.log(
          "this.print_header.tax_rate_amount: " +
            this.print_header.tax_rate_amount,
        );
      } else if (this.vat_type == "I") {
        this.print_header.amount_total = parseFloat(sub_total);
        this.print_header.sub_total = parseFloat(
          (sub_total * 100) / (100 + Number(this.vat)),
        );
        this.print_header.tax_rate_amount = parseFloat(
          this.print_header.amount_total - this.print_header.sub_total,
        );
      } else {
        return;
      }

      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      let matches = this.print_header.customer_name.match(checker_th);
      // const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      if (matches) {
        this.check_cus_name = false;
      } else {
        this.check_cus_name = true;
      }

      if (this.check_cus_name) {
        this.textamount_total_en = convert.toWords(
          this.print_header.amount_total.toFixed(2),
        );
        let setcheckscratch = false;
        this.textamount_total_en = this.textamount_total_en.replace(
          /\b./g,
          function(m) {
            if (m == ",") {
              return "";
            }
            if (m == "-") {
              setcheckscratch = true;
              return m;
            } else {
              if (setcheckscratch) {
                setcheckscratch = false;
                return m;
              }
              setcheckscratch = false;
              return m.toUpperCase();
            }
          },
        );
      } else {
        //start เปลี่ยนเป็นตัวอ่านไทย
        // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
        let thaiNumbers = [
          "",
          "หนึ่ง",
          "สอง",
          "สาม",
          "สี่",
          "ห้า",
          "หก",
          "เจ็ด",
          "แปด",
          "เก้า",
        ];
        let thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

        // แยกตัวจำนวนเต็มและทศนิยมห
        this.print_header.amount_total =
          Math.round(this.print_header.amount_total * 100) / 100;
        let [
          integerPart,
          decimalPart,
        ] = this.print_header.amount_total.toString().split(".");

        // แปลงส่วนทศนิยมเป็นข้อความไทย (สตางค์)
        let de_check = 0;

        if (decimalPart) {
          if (decimalPart.split("").length == 1) {
            if (Number(decimalPart) >= 10) {
              decimalPart = decimalPart;
            } else if (Number(decimalPart) > 0) {
              decimalPart = Number(decimalPart) * 10;
            } else {
              de_check = 1;
            }
          }
        } else {
          de_check = 1;
        }
        let decimalText = "";
        if (de_check == 0) {
          decimalPart = String(decimalPart);

          let numArrays = decimalPart.split("").map(Number);
          numArrays.forEach((num, index) => {
            let units = thaiUnits[numArrays.length - index - 1];
            let digits = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArrays.length - 1) {
                // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
                decimalText += "เอ็ด" + units;
              } else if (
                num === 2 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += "ยี่" + units;
              } else if (
                num === 1 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += units;
              } else {
                decimalText += digits + units;
              }
            }
          });

          decimalText = decimalText + "สตางค์";
        }

        // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
        let integerText = "";

        let numArray = integerPart.split("").map(Number);
        numArray.forEach((num, index) => {
          let unit = thaiUnits[numArray.length - index - 1];
          let digit = thaiNumbers[num];
          if (num !== 0) {
            if (num === 1 && index === numArray.length - 1) {
              // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
              integerText += "เอ็ด" + unit;
            } else if (
              num === 2 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += "ยี่" + unit;
            } else if (
              num === 1 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += unit;
            } else {
              integerText += digit + unit;
            }
          }
        });

        integerText = integerText + "บาท";

        let result = "";
        result = integerText + decimalText;
        this.textamount_total_en = result;
      }
    },
    async loadInvSoDataOth() {
      //data in table
      var tmp_inv_data;
      var sub_total = 0;
      var gran_total = 0;
      var sub_total_oth = 0;
      var gran_total_oth = 0;
      const res_inv_rc = await api.getDataPrint(this.main_id_print);

      tmp_inv_data = res_inv_rc.data;
      console.log("res_inv_rc.data:");
      console.log("");
      tmp_inv_data.forEach((item, index) => {
        var data = {
          no: 0,
          inv_id: "",
          date: null,
          credit_term: 0,
          currency: "",
          amount: 0,
          amount_s: 0,
          amount_s_ex: 0,
          amount_sub: 0,
        };
        data.no = index + 1;
        data.inv_id = item.inv_id;
        data.date = item.date_show;
        data.credit_term = item.credit_term;
        data.currency = item.currency;
        data.amount = Number(item.inv_amount_total);
        if (this.vat_type == "E") {
          data.amount_s = Number(item.inv_amount_total).toFixed(2);
        } else if (this.vat_type == "I") {
          // data.amount_s = (data.amount  inv_sub_total(data.amount * (this.vat / 100))).toFixed(2);
          data.amount_s = Number(item.inv_amount_total).toFixed(2);
        } else {
          return;
        }
        data.amount_sub = Number(item.inv_sub_total).toFixed(2);

        data.amount_s_ex = Number(data.amount_s) * this.exchange_rate;
        data.amount_s_ex = Number(data.amount_s_ex.toFixed(2));
        data.amount_s = parseFloat(data.amount_s);
        data.amount_s_ex = parseFloat(data.amount_s_ex);
        this.print_table_detail.push(data);

        this.curency_show_tb = "";
        this.curency_show_tb = item.currency;

        sub_total_oth = Number(sub_total_oth) + Number(data.amount_sub);
        gran_total_oth = Number(gran_total_oth) + Number(data.amount_s);
        gran_total = Number(gran_total) + Number(data.amount_s_ex);
      });
      sub_total_oth = sub_total_oth.toFixed(2);
      gran_total_oth = gran_total_oth.toFixed(2);
      gran_total = gran_total.toFixed(2);
      console.log("gran_total_oth");
      console.log(gran_total_oth);
      // if(this.vat_type == "E"){
      //   this.print_header.sub_total_oth = parseFloat(Number(gran_total_oth).toFixed(2));
      //   this.print_header.tax_rate_amount_oth = parseFloat(Number(this.print_header.sub_total_oth * (this.vat/100)).toFixed(2));
      //   this.print_header.amount_total_oth = parseFloat(Number(this.print_header.sub_total_oth + this.print_header.tax_rate_amount_oth).toFixed(2));

      //   this.print_header.amount_total = parseFloat(Number(this.print_header.amount_total_oth * this.exchange_rate).toFixed(2));
      //   this.print_header.sub_total = parseFloat(Number(this.print_header.sub_total_oth * this.exchange_rate).toFixed(2));
      //   this.print_header.tax_rate_amount = parseFloat(this.print_header.amount_total - this.print_header.sub_total);
      //   //
      // }else  if(this.vat_type == "I"){
      this.print_header.amount_total_oth = parseFloat(
        Number(gran_total_oth).toFixed(2),
      );
      this.print_header.sub_total_oth = parseFloat(
        Number(sub_total_oth).toFixed(2),
      );
      this.print_header.tax_rate_amount_oth = parseFloat(
        this.print_header.amount_total_oth - this.print_header.sub_total_oth,
      );

      this.print_header.amount_total = parseFloat(
        Number(this.print_header.amount_total_oth * this.exchange_rate).toFixed(
          2,
        ),
      );
      this.print_header.sub_total = parseFloat(
        Number(this.print_header.amount_total / (1 + this.vat / 100)).toFixed(
          2,
        ),
      );
      this.print_header.tax_rate_amount = parseFloat(
        this.print_header.amount_total - this.print_header.sub_total,
      );
      // }else{

      // }
      console.log("this.print_header");
      console.log(this.print_header);
      // this.print_header.amount_total_oth = parseFloat(gran_total_oth);
      // this.print_header.amount_total = parseFloat(gran_total);

      // sub_total_oth = (this.print_header.amount_total_oth / (1 + (this.vat / 100))).toFixed(2)
      // sub_total = (this.print_header.amount_total / (1 + (this.vat / 100))).toFixed(2)
      // this.print_header.sub_total_oth = parseFloat(sub_total_oth);
      // this.print_header.sub_total = parseFloat(sub_total);

      // this.print_header.tax_rate_amount_oth = parseFloat(this.print_header.amount_total_oth - sub_total_oth)
      // this.print_header.tax_rate_amount = parseFloat(this.print_header.amount_total - sub_total)

      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      let matches = this.print_header.customer_name.match(checker_th);
      // const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      if (matches) {
        this.check_cus_name = false;
      } else {
        this.check_cus_name = true;
      }

      if (this.check_cus_name) {
        this.textamount_total_en = convert.toWords(
          this.print_header.amount_total.toFixed(2),
        );
        let setcheckscratch = false;
        this.textamount_total_en = this.textamount_total_en.replace(
          /\b./g,
          function(m) {
            if (m == ",") {
              return "";
            }
            if (m == "-") {
              setcheckscratch = true;
              return m;
            } else {
              if (setcheckscratch) {
                setcheckscratch = false;
                return m;
              }
              setcheckscratch = false;
              return m.toUpperCase();
            }
          },
        );
      } else {
        //start เปลี่ยนเป็นตัวอ่านไทย
        // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
        var thaiNumbers = [
          "",
          "หนึ่ง",
          "สอง",
          "สาม",
          "สี่",
          "ห้า",
          "หก",
          "เจ็ด",
          "แปด",
          "เก้า",
        ];
        var thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

        // แยกตัวจำนวนเต็มและทศนิยมห
        this.print_header.amount_total =
          Math.round(this.print_header.amount_total * 100) / 100;
        var [
          integerPart,
          decimalPart,
        ] = this.print_header.amount_total.toString().split(".");

        // แปลงส่วนทศนิยมเป็นข้อความไทย (สตางค์)
        let de_check = 0;
        if (decimalPart) {
          if (decimalPart.split("").length == 1) {
            if (Number(decimalPart) >= 10) {
              decimalPart = decimalPart;
            } else if (Number(decimalPart) > 0) {
              decimalPart = Number(decimalPart) * 10;
            } else {
              de_check = 1;
            }
          }
        } else {
          de_check = 1;
        }

        let decimalText = "";
        if (de_check == 0) {
          decimalPart = String(decimalPart);

          var numArrays = decimalPart.split("").map(Number);
          numArrays.forEach((num, index) => {
            var units = thaiUnits[numArrays.length - index - 1];
            var digits = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArrays.length - 1) {
                // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
                decimalText += "เอ็ด" + units;
              } else if (
                num === 2 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += "ยี่" + units;
              } else if (
                num === 1 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += units;
              } else {
                decimalText += digits + units;
              }
            }
          });

          decimalText = decimalText + "สตางค์";
        }

        // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
        let integerText = "";

        var numArray = integerPart.split("").map(Number);
        numArray.forEach((num, index) => {
          var unit = thaiUnits[numArray.length - index - 1];
          var digit = thaiNumbers[num];
          if (num !== 0) {
            if (num === 1 && index === numArray.length - 1) {
              // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
              integerText += "เอ็ด" + unit;
            } else if (
              num === 2 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += "ยี่" + unit;
            } else if (
              num === 1 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += unit;
            } else {
              integerText += digit + unit;
            }
          }
        });

        integerText = integerText + "บาท";

        var result = "";
        result = integerText + decimalText;
        this.textamount_total_en = result;
      }
      // this.print_header.sub_total = sub_total;
    },
    async loadRcData() {
      //data in table
      var tmp_inv_data;
      var sub_total = 0;
      const res_inv_rc = await api.getDataReceiveDByID(this.main_id_print);

      tmp_inv_data = res_inv_rc.data;

      tmp_inv_data.forEach((item, index) => {
        var data = {
          description: "",
          quantity: 0,
          amount: 0,
        };

        data.description = item.inv_detail;
        data.quantity = parseFloat(item.inv_qty);
        data.amount = parseFloat(item.inv_lineamount);
        this.print_table_Rcdetail.push(data);
        sub_total = sub_total + parseFloat(item.inv_lineamount);
      });
      if (this.vat_type == "E") {
        this.print_detail_header.sub_total = parseFloat(
          Number(sub_total).toFixed(2),
        );
        this.print_detail_header.tax_rate_amount = parseFloat(
          Number(
            (this.print_detail_header.sub_total * this.tax_detail_rate) / 100,
          ).toFixed(2),
        );
        this.print_detail_header.amount_total = parseFloat(
          this.print_detail_header.sub_total +
            this.print_detail_header.tax_rate_amount,
        );
      } else if (this.vat_type == "I") {
        this.print_detail_header.amount_total = parseFloat(
          Number(sub_total).toFixed(2),
        );
        this.print_detail_header.sub_total = parseFloat(
          Number(sub_total / (1 + this.tax_detail_rate / 100)).toFixed(2),
        );
        this.print_detail_header.tax_rate_amount = parseFloat(
          this.print_detail_header.amount_total -
            this.print_detail_header.sub_total,
        );
      } else {
      }

      // this.textamount_total_en = convert.toWords(
      //   this.print_detail_header.amount_total.toFixed(2)
      // );

      //check lag
      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      let matches = this.print_detail_header.customer_name.match(checker_th);
      // const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      if (matches) {
        this.check_cus_name = false;
      } else {
        this.check_cus_name = true;
      }

      if (this.check_cus_name) {
        this.textamount_total_en = convert.toWords(
          this.print_detail_header.amount_total.toFixed(2),
        );

        let setcheckscratch = false;
        this.textamount_total_en = this.textamount_total_en.replace(
          /\b./g,
          function(m) {
            if (m == ",") {
              return "";
            }
            if (m == "-") {
              setcheckscratch = true;
              return m;
            } else {
              if (setcheckscratch) {
                setcheckscratch = false;
                return m;
              }
              setcheckscratch = false;
              return m.toUpperCase();
            }
          },
        );
      } else {
        var result = "";

        //start เปลี่ยนเป็นตัวอ่านไทย
        // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
        var thaiNumbers = [
          "",
          "หนึ่ง",
          "สอง",
          "สาม",
          "สี่",
          "ห้า",
          "หก",
          "เจ็ด",
          "แปด",
          "เก้า",
        ];
        var thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

        // แยกตัวจำนวนเต็มและทศนิยมห
        this.print_detail_header.amount_total =
          Math.round(this.print_detail_header.amount_total * 100) / 100;
        var [
          integerPart,
          decimalPart,
        ] = this.print_detail_header.amount_total.toString().split(".");

        let de_check = 0;
        if (decimalPart) {
          if (decimalPart.split("").length == 1) {
            if (Number(decimalPart) >= 10) {
              decimalPart = decimalPart;
            } else if (Number(decimalPart) > 0) {
              decimalPart = Number(decimalPart) * 10;
            } else {
              de_check = 1;
            }
          }
        } else {
          de_check = 1;
        }

        let decimalText = "";
        if (de_check == 0) {
          decimalPart = String(decimalPart);

          let numArrays = decimalPart.split("").map(Number);
          numArrays.forEach((num, index) => {
            let units = thaiUnits[numArrays.length - index - 1];
            let digits = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArrays.length - 1) {
                // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
                decimalText += "เอ็ด" + units;
              } else if (
                num === 2 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += "ยี่" + units;
              } else if (
                num === 1 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += units;
              } else {
                decimalText += digits + units;
              }
            }
          });

          decimalText = decimalText + "สตางค์";
        }

        // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
        let integerText = "";

        let numArray = integerPart.split("").map(Number);
        numArray.forEach((num, index) => {
          let unit = thaiUnits[numArray.length - index - 1];
          let digit = thaiNumbers[num];
          if (num !== 0) {
            if (num === 1 && index === numArray.length - 1) {
              // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
              integerText += "เอ็ด" + unit;
            } else if (
              num === 2 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += "ยี่" + unit;
            } else if (
              num === 1 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += unit;
            } else {
              integerText += digit + unit;
            }
          }
        });

        integerText = integerText + "บาท";

        result = integerText + decimalText;
        this.textamount_total_en = result;
        console.log("this.textamount_total_en: " + this.textamount_total_en);
      }
    },
    async loadMainInvSoData() {
      // var tmp_inv_data;
      // this.print_header = {};
      // const res_inv_so = await api.getdataByIdInvoice_HRC(this.inv_id);

      const res_inv_so = await api.getPrintDataByIdAndCusTypeInvoice_HRC(
        this.inv_id,
        this.dialogSelectClientInfoReceipt,
      );

      if (res_inv_so.data[0].company_inv == "D") {
        this.getcompany_id = 1;
        this.print_header = this.print_header_list[0];
        this.print_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
      } else if (res_inv_so.data[0].company_inv == "L") {
        this.getcompany_id = 1;
        this.print_header = this.print_header_list[1];
        this.print_header.com_title = "RECEIPT";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน";
      } else {
        this.getcompany_id = res_inv_so.data[0].company_inv;
        this.print_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
        this.print_header.com_name = res_inv_so.data[0].com_name;
        this.print_header.inv_company_address =
          res_inv_so.data[0].inv_company_address;
        this.print_header.inv_company_branch =
          res_inv_so.data[0].inv_company_branch;
        this.print_header.inv_company_tel = res_inv_so.data[0].inv_company_tel;
        this.print_header.inv_company_email =
          res_inv_so.data[0].inv_company_email;
        this.print_header.inv_tax_id = res_inv_so.data[0].inv_tax_id;
        this.print_header.inv_company_name_th =
          res_inv_so.data[0].inv_company_name_th;
      }
      this.currency_show = res_inv_so.data[0].currency;
      this.print_header.customer_name = res_inv_so.data[0].customer_name;
      // this.print_header.invoice_date = res_inv_so.data[0].date;
      this.print_header.addressall = res_inv_so.data[0].addressall;
      this.print_header.customer_address = res_inv_so.data[0].customer_address;

      this.print_header.province_invoice = res_inv_so.data[0].province_invoice;
      this.print_header.country_invoice = res_inv_so.data[0].country_invoice;
      this.print_header.zipcode_invoice = res_inv_so.data[0].zipcode_invoice;

      this.print_header.period_cover = res_inv_so.data[0].inv_id
        ? res_inv_so.data[0].inv_id
        : res_inv_so.data[0].pinv_id;
      this.print_header.customer_contact_name =
        res_inv_so.data[0].customer_contact_name;
      // this.print_header.customer_taxid = res_inv_so.data[0].customer_taxid;
      this.print_header.customer_taxid =
        `${res_inv_so.data[0].customer_taxid} ${(res_inv_so.data[0].customer_branch && res_inv_so.data[0].customer_branch!=="")?` / ${res_inv_so.data[0].customer_branch}`:'' }`;
      this.branch_cus = res_inv_so.data[0].customer_branch;
      this.print_header.tax_rate = this.tax_rate;
      this.print_header.company_inv = res_inv_so.data[0].company_inv;
      // alert(this.branch_cus)
    },
    async loadMainRcData() {
      // this.print_detail_header = {};
      // var tmp_inv_data;
      // const res_inv_so = await api.getdataByIdInvoice_HRC(this.inv_detail_id);
      const res_inv_so = await api.getPrintDataByIdAndCusTypeInvoice_HRC(
        this.inv_detail_id,
        this.dialogSelectClientInfoReceipt,
      );
      if (res_inv_so.data[0].company_inv == "D") {
        this.getcompany_id = 1;
        this.print_detail_header = this.print_header_list_detail[0];
        this.print_detail_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
      } else if (res_inv_so.data[0].company_inv == "L") {
        this.getcompany_id = 1;
        this.print_detail_header = this.print_header_list_detail[1];
        this.print_detail_header.com_title = "RECEIPT";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน";
      } else {
        this.getcompany_id = res_inv_so.data[0].company_inv;
        this.print_detail_header.com_title = "RECEIPT / TAX INVOICE";
        this.print_detail_header.com_title_th = "ใบเสร็จรับเงิน / ใบกำกับภาษี";
        this.print_detail_header.com_name = res_inv_so.data[0].com_name;
        this.print_detail_header.inv_company_address =
          res_inv_so.data[0].inv_company_address;
        this.print_detail_header.inv_company_branch =
          res_inv_so.data[0].inv_company_branch;
        this.print_detail_header.inv_company_tel =
          res_inv_so.data[0].inv_company_tel;
        this.print_detail_header.inv_company_email =
          res_inv_so.data[0].inv_company_email;
        this.print_detail_header.inv_tax_id = res_inv_so.data[0].inv_tax_id;
        this.print_detail_header.inv_company_name_th =
          res_inv_so.data[0].inv_company_name_th;
      }
      this.currency_show = res_inv_so.data[0].currency;
      this.print_detail_header.customer_name = res_inv_so.data[0].customer_name;
      // this.print_header.invoice_date = res_inv_so.data[0].date;
      this.print_detail_header.addressall = res_inv_so.data[0].addressall;
      this.print_detail_header.customer_address =
        res_inv_so.data[0].customer_address;

      this.print_detail_header.province_invoice =
        res_inv_so.data[0].province_invoice;
      this.print_detail_header.country_invoice =
        res_inv_so.data[0].country_invoice;
      this.print_detail_header.zipcode_invoice =
        res_inv_so.data[0].zipcode_invoice;

      this.print_detail_header.period_cover = res_inv_so.data[0].inv_id
        ? res_inv_so.data[0].inv_id
        : res_inv_so.data[0].pinv_id;
      this.print_detail_header.customer_contact_name =
        res_inv_so.data[0].customer_contact_name;
      this.print_detail_header.customer_taxid =
        res_inv_so.data[0].customer_taxid;
      // alert(res_inv_so.data[0].customer_taxid)
      this.branch_cus = res_inv_so.data[0].customer_branch;
      this.print_detail_header.tax_rate = this.vat;
      this.print_detail_header.company_inv = res_inv_so.data[0].company_inv;
    },
    async checkcontent() {
      // เคลียร์ข้อมูลก่อน
      this.datashowAll = [];
      this.setdatatoshow = [];

      // จำนวนบรรทัดสูงสุดต่อหน้า (ไม่รวม footer)
      const linedetailprpo = 18;

      // ความยาวของข้อความที่คิดว่าแสดงได้ต่อบรรทัด
      const datainlineprpo = 80;

      // กำหนดว่าหน้าสุดท้ายจะมี footer ที่กินพื้นที่กี่บรรทัด
      const footerLines = 5;

      // ตัวแปรช่วยเก็บข้อมูลชั่วคราว
      let getdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;

      // วนข้อมูลทีละรายการ
      for (let i = 0; i < this.print_table_detail.length; i++) {
        // เตรียมข้อมูลตรวจความยาว (ใช้วัดจำนวนบรรทัด)
        let lengthofdataforshowprpo = this.print_table_detail[i].inv_id.length;

        // อักษรไทยบางตัวที่ไม่กินความกว้าง ต้องหักออกจากความยาวที่ใช้ในการคำนวณ
        const zeroWidthChars = [
          "่",
          "้",
          "๊",
          "๋",
          "ิ",
          "ี",
          "ึ",
          "ื",
          "ุ",
          "ู",
          "ั",
          "็",
        ];

        // หักอักขระพิเศษที่ไม่กินพื้นที่ออกจากความยาว
        for (let j = 0; j < this.print_table_detail[i].inv_id.length; j++) {
          if (zeroWidthChars.includes(this.print_table_detail[i].inv_id[j])) {
            lengthofdataforshowprpo--;
          }
        }

        // คำนวณว่าใช้กี่บรรทัด
        const newhllinedetails = Math.ceil(
          lengthofdataforshowprpo / datainlineprpo,
        );

        // ใส่หมายเลขบรรทัด
        this.print_table_detail[i].no = i + 1;

        // ปรับจำนวนบรรทัดต่อหน้าสำหรับหน้าสุดท้าย
        let currentPageLineLimit = linedetailprpo;
        const isLastItem = i === this.print_table_detail.length - 1;

        // ถ้าเป็นหน้าสุดท้าย ให้ลดจำนวนบรรทัดเผื่อ footer
        if (isLastItem) {
          currentPageLineLimit -= footerLines;
        }

        // ถ้าข้อมูลนี้ทำให้บรรทัดเกินหน้า → แยกหน้าใหม่
        if (hllinedetails + newhllinedetails > currentPageLineLimit) {
          // เก็บหน้าปัจจุบันไว้
          this.setdatatoshow[this.pageAll - 1] = getdata;

          // ขึ้นหน้าใหม่
          this.pageAll++;
          hllinedetails = 0;
          getdata = [];

          // ใส่รายการนี้เป็นรายการแรกของหน้าใหม่
          getdata.push(this.print_table_detail[i]);
          hllinedetails += newhllinedetails;

          // ถ้าเป็นรายการสุดท้าย ให้เก็บไว้เลย
          if (isLastItem) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
          }
        } else {
          // ถ้ายังไม่เกินหน้า → เพิ่มรายการเข้าไปในหน้าปัจจุบัน
          hllinedetails += newhllinedetails;
          getdata.push(this.print_table_detail[i]);

          // ถ้าเป็นรายการสุดท้าย → เก็บหน้าไว้
          if (isLastItem) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
          }
        }
      }

      // เปิดหน้าสรุป (อาจใช้แสดงหน้า preview)
      this.opensummarize = true;

      // ใส่ flag 'lastdata' ให้กับแถวสุดท้ายของหน้าสุดท้าย
      this.setdatatoshow.forEach((item, iitem) => {
        if (iitem === this.setdatatoshow.length - 1) {
          item[item.length - 1].lastdata = "lastindex";
        }
        this.datashowAll.push(item);
      });
    },
    async checkcontentdetail() {
      this.datashowAllDetail = [];
      // alert(data.length);
      this.setdatatoshowDetail = [];
      let linedetailprpo = 17;
      let datainlineprpo = 50;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAllDetail = 1;
      let newhllinedetails = 0;
      for (let i = 0; i < this.print_table_Rcdetail.length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo = this.print_table_Rcdetail[i].description
          .length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.print_table_Rcdetail[i].no = i + 1;

        for (
          let j = 0;
          j < this.print_table_Rcdetail[i].description.length;
          j++
        ) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);

        getnewdata.push(this.print_table_Rcdetail[i]);

        if (hllinedetails + newhllinedetails > linedetailprpo) {
          this.setdatatoshowDetail[this.pageAllDetail - 1] = getdata;
          this.pageAllDetail++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.print_table_Rcdetail[i]);
          hllinedetails += newhllinedetails;
          if (i == this.print_table_Rcdetail.length - 1) {
            this.setdatatoshowDetail[this.pageAllDetail - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.print_table_Rcdetail[i]);

          if (i == this.print_table_Rcdetail.length - 1) {
            this.setdatatoshowDetail[this.pageAllDetail - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.opensummarizeDetail = true;

      this.setdatatoshowDetail.forEach((item, iitem) => {
        if (iitem == this.setdatatoshowDetail.length - 1) {
          item[this.setdatatoshowDetail[iitem].length - 1].lastdata =
            "lastindex";
        }

        this.datashowAllDetail.push(item);
      });
    },
    async exportToPDF() {
      // this.$refs.html2Pdf.generatePdf();

      // :datashowAll="datashowAll"
      //       :print_header="print_header"
      //       :heighttabledetail="heighttabledetail"
      //       :currency_print="currency_print"
      //       :check_cus_name="check_cus_name"
      //       :textamount_total_en="textamount_total_en"
      //       :checklawoffice="checklawoffice"
      //       :exchange_rate="exchange_rate"
      //       :branch_cus="branch_cus"
      //       :payment_by_print="payment_by_print"
      //       :bank_name_show="bank_name_show"
      //       :bank_no_show="bank_no_show"

      let main_data_to_print = {
        main_data: {
          datashowAll: this.datashowAll,
          print_header: this.print_header,
          heighttabledetail: this.heighttabledetail,
          currency_print: this.currency_print,
          check_cus_name: this.check_cus_name,
          textamount_total_en: this.textamount_total_en,
          checklawoffice: this.checklawoffice,
          exchange_rate: this.exchange_rate,
          branch_cus: this.branch_cus,
          payment_by_print: this.payment_by_print,
          bank_name_show: this.bank_name_show,
          bank_no_show: this.bank_no_show,
        },
      };

      console.log(`main_data_to_print ${JSON.stringify(main_data_to_print)}`);

      this.showprint = "";
      let element = document.getElementById("mydivhtmltobase");
      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function(pdf) {
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          return pdf.output("bloburl");
        });

      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      this.showprint = "display:none;";

      return;
    },
    async exportToPDFDetail() {
      this.showprintDetail = "";

      // :datashowAllDetail="datashowAllDetail"
      //       :print_detail_header="print_detail_header"
      //       :heighttabledetail="heighttabledetail"
      //       :currency_print="currency_print"
      //       :check_cus_name="check_cus_name"
      //       :textamount_total_en="textamount_total_en"
      //       :checklawoffice="checklawoffice"
      //       :exchange_rate="exchange_rate"
      //       :branch_cus="branch_cus"
      //       :payment_by_print="payment_by_print"
      //       :bank_name_show="bank_name_show"
      //       :bank_no_show="bank_no_show"
      //       :currency_show="currency_show"

      let main_data_to_print_detail = {
        main_data: {
          datashowAll: this.datashowAllDetail,
          print_header: this.print_detail_header,
          heighttabledetail: this.heighttabledetail,
          currency_print: this.currency_print,
          check_cus_name: this.check_cus_name,
          textamount_total_en: this.textamount_total_en,
          checklawoffice: this.checklawoffice,
          exchange_rate: this.exchange_rate,
          branch_cus: this.branch_cus,
          payment_by_print: this.payment_by_print,
          bank_name_show: this.bank_name_show,
          bank_no_show: this.bank_no_show,
          currency_show: this.currency_show,
        },
      };

      console.log(
        `main_data_to_print_detail ${JSON.stringify(
          main_data_to_print_detail,
        )}`,
      );

      const element = document.getElementById("mydivhtmltobaseDetail");
      const opt = {
        margin: [0, 0, 0, 0],
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: {
          scale: 1.5,
          dpi: 144,
          letterRendering: true,
          useCORS: true,
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
      };

      try {
        let abcd = await html2pdf()
          .from(element)
          .set(opt)
          .toPdf()
          .get("pdf")
          .then(function(pdf) {
            const totalPages = pdf.internal.getNumberOfPages();
            console.log("Total pages generated:", totalPages);

            // ลบหน้าสุดท้ายก็ต่อเมื่อมีมากกว่า 1 หน้าเท่านั้น
            if (totalPages > 1) {
              pdf.deletePage(totalPages);
            }

            return pdf.output("bloburl");
          });

        window.open(abcd);
        let blob = await fetch(abcd).then((r) => r.blob());
      } catch (err) {
        console.error("PDF export failed:", err);
      } finally {
        this.showprintDetail = "display:none;";
      }

      return;
    },
    async printReceive() {
      if (this.dialogSelect == "1") {
        // alert(this.currency_print)
        this.datashowAll = [];
        this.print_table_detail = [];
        this.dialogSelectPrint = false;
        this.$showLoader();
        await this.loadRef_TypeRcById();
        await this.loadMainInvSoData();
        if (this.currency_print == "THB") {
          await this.loadInvSoData();
        } else {
          await this.loadInvSoDataOth();
        }
        await this.checkcontent();
        // await this.exportToPDF();

        // เรียกแบบนี้
        await this.exportReceiptToPDFMake();

        this.$hideLoader();
      } else {
        this.datashowAllDetail = [];
        this.print_table_Rcdetail = [];
        this.dialogSelectPrint = false;
        this.$showLoader();
        await this.loadRef_TypeRcDetailById();
        await this.loadMainRcData();
        await this.loadRcData();
        await this.checkcontentdetail();
        // await this.exportToPDFDetail();
        // ใช้ pdfMake สำหรับ Detail แทน html2pdf
        await this.exportReceiptDetailToPDFMake();
        this.$hideLoader();
      }
    },
    async SumDataT() {
      let sum_data = 0;
      this.mDataArrayforinv.forEach((item) => {
        item.inv_lineamount = Number(stringcommatonumber(item.inv_lineamount));
        sum_data = sum_data + Number(item.inv_lineamount);
        item.inv_lineamount = tolocalestringnumber(item.inv_lineamount);
      });

      if (this.vat_type == "E") {
        this.inv_subtotal = tolocalestringnumber(sum_data);
        this.wth_ratetotal = tolocalestringnumber(
          (Number(this.wth_rate) / 100) * sum_data,
        );
        this.tax_ratetotal = tolocalestringnumber(
          Number((this.vat / 100) * sum_data),
        );
        this.amount_total = tolocalestringnumber(
          sum_data -
            (Number(this.wth_rate) / 100) * sum_data +
            Number((this.vat / 100) * sum_data),
        );
      } else if (this.vat_type == "I") {
        this.amount_total = tolocalestringnumber(
          sum_data / (1 + Number(this.wth_rate) / 100),
        );
        this.wth_ratetotal = tolocalestringnumber(
          Number(sum_data - stringcommatonumber(this.amount_total)).toFixed(2),
        );
        this.inv_subtotal = tolocalestringnumber(
          Number(
            stringcommatonumber(this.amount_total) / (1 + this.vat / 100),
          ).toFixed(2),
        );
        this.tax_ratetotal = tolocalestringnumber(
          Number(
            stringcommatonumber(this.amount_total) -
              stringcommatonumber(this.inv_subtotal),
          ).toFixed(2),
        );
      } else {
      }
    },
    async loadinv_handcal() {
      const res_rc_detail = await api.getDataReceiveDByID(this.main_id_print);
      this.desserts = res_rc_detail.data;
      this.desserts.forEach(async (item, index) => {
        item.inv_qty = tolocalestringnumber(item.inv_qty);
        item.inv_price = tolocalestringnumber(
          item.inv_lineamount / item.inv_qty,
        );
        item.inv_lineamount = tolocalestringnumber(item.inv_lineamount);
        if (index == this.desserts.length - 1) {
          this.mDataArrayforinv = this.desserts;
        }
      });
    },
    async loadCustomer() {
      if (this.main_customer_id != 0) {
        const res_customer = await api.getCustomersById(this.main_customer_id);
        if (res_customer.data[0]) {
          this.vat_type = res_customer.data[0].vat_type;
        }
      }
    },

    waitForPdfMakeReady() {
      return new Promise((resolve, reject) => {
        const checkInterval = setInterval(() => {
          if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
            clearInterval(checkInterval);
            console.log("✅ pdfMake พร้อมใช้งาน พร้อมฟอนต์ภาษาไทย");
            resolve(true);
          }
        }, 100);

        setTimeout(() => {
          clearInterval(checkInterval);
          reject(new Error("pdfMake โหลดไม่สำเร็จ"));
        }, 10000);
      });
    },

    formatNumber(value) {
      if (!value && value !== 0) return "0.00";
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },

    formatDate(dateString) {
      if (!dateString) return "";
      if (dateString.includes("/")) {
        return dateString;
      }

      const date = new Date(dateString);
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    createHeader() {
      return {
        columns: [
          {
            width: "50%",
            stack: [
              {
                text: this.header.com_eng_1 || "DEJ-UDOM & ASSOCIATES LTD.",
                fontSize: 11,
                bold: true,
                margin: [0, 0, 0, 1],
              },
              {
                text: this.header.com_eng_2 || "ATTORNEY AT LAW",
                fontSize: 8,
                bold: true,
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_thai ||
                  "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                fontSize: 8,
                margin: [0, 0, 0, 1],
              },
            ],
          },
          {
            width: "50%",
            stack: [
              {
                text:
                  this.header.com_add_name ||
                  "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: this.header.com_add_no || "942/69 RAMA IV ROAD,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_city ||
                  "KWAENG SURIYAWONG, KHET BANGRAK,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: this.header.com_add_country || "BANGKOK 10500, THAILAND",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_tel || "Tel : 0-2233-0055, 0-2233-0068",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_email || "E-MAIL : account@dejudom.com",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_tax_id ||
                  'TAX ID. No. 0105534015348 / "HEAD OFFICE"',
                fontSize: 7,
                alignment: "right",
                bold: true,
              },
            ],
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    createTitle() {
      return {
        stack: [
          {
            text: this.header.com_title || "RECEIPT / TAX INVOICE",
            fontSize: 14,
            bold: true,
            alignment: "center",
            margin: [0, 15, 0, 2],
          },
          {
            text: this.header.com_title_th || "ใบเสร็จรับเงิน / ใบกำกับภาษี",
            fontSize: 12,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 10],
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 0,
                x2: 515,
                y2: 0,
                lineWidth: 1,
              },
            ],
            margin: [0, 0, 0, 10],
          },
        ],
      };
    },

    createCustomerInfo() {
      const addressLines = (this.header.addressall || "").split("\n");
      const filteredAddress = addressLines
        .filter((line) => line.trim() !== "" && line.trim() !== ",")
        .join(", ");

      // สร้าง array สำหรับข้อมูลด้านขวา
      const rightColumnStack = [
        {
          text: `No. / เลขที่ : ${this.header.inv_id || "________"}`,
          fontSize: 9,
          alignment: "right",
          margin: [0, 0, 0, 5],
        },
        {
          text: `Date / วันที่ : ${this.formatDate(this.header.invoice_date) ||
            "______________"}`,
          fontSize: 9,
          alignment: "right",
          margin: [0, 0, 0, 5],
        },
      ];

      // เพิ่ม Exchange Rate เฉพาะเมื่อไม่ใช่ THB
      if (this.currency_print !== "THB") {
        rightColumnStack.push({
          text: `Exchange Rate : ${this.exchangeRate || "______________"}`,
          fontSize: 9,
          alignment: "right",
        });
      }

      return {
        columns: [
          {
            width: "70%",
            stack: [
              {
                columns: [
                  {
                    width: 60,
                    text: "To / ถึง:",
                    fontSize: 9,
                  },
                  {
                    width: "*",
                    text: this.header.customer_name || "Customer Name",
                    fontSize: 9,
                    bold: true,
                  },
                ],
                margin: [0, 0, 0, 3],
              },
              {
                columns: [
                  {
                    width: 60,
                    text: "",
                    fontSize: 8,
                  },
                  {
                    width: "*",
                    text:
                      filteredAddress ||
                      "Address Line 1, address line 1, address line 1,\nAddress Line 2, address line 2, address line 2, address line 2\nAddress Line 3, address line 3, address line 3, address line 3\nCity, Postcode, COUNTRY",
                    fontSize: 8,
                  },
                ],
                margin: [0, 0, 0, 3],
              },
              {
                columns: [
                  {
                    width: 60,
                    text: "Tax ID:",
                    fontSize: 9,
                  },
                  { 
                    width: "*",
                    text: `${this.header.customer_taxid || "__________________"} ${this.header.customer_branch?` / ${this.header.customer_branch}`:''}`,
                    fontSize: 9,
                  },
                ],
              },
            ],
          },
          {
            width: "30%",
            stack: rightColumnStack, // ใช้ array ที่สร้างไว้
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    createItemsTable() {
      const tableWidths = this.showCurrencyColumn
        ? [35, "*", 70, 80, 80]
        : [35, "*", 70, 80];

      const headerRow = [
        {
          text: "No.",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
        {
          text: "Statement No./ เลขที่ใบเเจ้งหนี้",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
        {
          text: "Date / วันที่",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
      ];

      if (this.showCurrencyColumn) {
        headerRow.push({
          text: "Currency / Amount",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        });
      }

      headerRow.push({
        text: "Amount / จำนวนเงิน",
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [2, 3, 2, 3],
      });

      const bodyRows = [];
      const minRows = 7;

      for (let i = 0; i < minRows; i++) {
        if (i < this.items.length) {
          const item = this.items[i];
          console.log(`item tavle : ${JSON.stringify(item)}`);

          const row = [
            {
              text: item.no || "",
              fontSize: 9,
              alignment: "center",
              margin: [2, 3, 2, 3],
            },
            {
              text: item.inv_id || "",
              fontSize: 9,
              margin: [2, 3, 2, 3],
            },
            {
              text: this.formatDate(item.date) || "",
              fontSize: 9,
              alignment: "center",
              margin: [2, 3, 2, 3],
            },
          ];

          if (this.showCurrencyColumn) {
            row.push({
              text: item.amount ? this.formatNumber(item.amount) : "",
              fontSize: 9,
              alignment: "right",
              margin: [2, 3, 2, 3],
            });
          }

          row.push({
            text: item.amount_s ? this.formatNumber(item.amount_s) : "",
            fontSize: 9,
            alignment: "right",
            margin: [2, 3, 2, 3],
          });

          bodyRows.push(row);
        } else {
          const emptyRow = [
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
          ];

          if (this.showCurrencyColumn) {
            emptyRow.push({
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            });
          }

          emptyRow.push({
            text: "",
            fontSize: 9,
            margin: [2, 15, 2, 15],
          });
          bodyRows.push(emptyRow);
        }
      }

      return {
        table: {
          headerRows: 1,
          widths: tableWidths,
          body: [headerRow, ...bodyRows],
        },
        layout: {
          hLineWidth: function(i, node) {
            // if (i === 0 || i === 1 || i === node.table.body.length) {
            if (i === 0 || i === 1) {
              return 1;
            }
            return 0;
          },
          vLineWidth: function(i) {
            return 1;
          },
          paddingLeft: function() {
            return 0;
          },
          paddingRight: function() {
            return 0;
          },
          paddingTop: function() {
            return 0;
          },
          paddingBottom: function() {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createSummaryTable() {
      const subTotal = this.header.sub_total || 0;
      const subTotalOth = this.header.sub_total_oth || 0;
      const taxRate = this.header.tax_rate || "7.00";
      const taxAmount = this.header.tax_rate_amount || 0;
      const taxAmountOth = this.header.tax_rate_amount_oth || 0;
      const grandTotal = this.header.amount_total || 0;
      const grandTotalOth = this.header.amount_total_oth || 0;
      let currency = this.currencyPrint || "USD";
      currency = currency.replace("US", "USD");
      currency = currency.replace("USDD", "USD");

      const summaryWidths = this.showCurrencyColumn
        ? [35, "*", 70, 80, 80]
        : [35, "*", 70, 80];

      const summaryRows = [];

      const subTotalRow = [
        {
          text: "Sub Total / รวมเป็นเงิน",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 3,
        },
        { text: "" },
        { text: "" },
      ];

      if (this.showCurrencyColumn) {
        subTotalRow.push({
          text: `${currency} ${this.formatNumber(subTotalOth)}`,
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        });
      }

      subTotalRow.push({
        text: this.formatNumber(subTotal),
        fontSize: 9,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });

      summaryRows.push(subTotalRow);

      const vatRow = [
        {
          text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${taxRate} %)`,
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 3,
        },
        { text: "" },
        { text: "" },
      ];

      if (this.showCurrencyColumn) {
        vatRow.push({
          text: `${currency} ${this.formatNumber(taxAmountOth)}`,
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        });
      }

      vatRow.push({
        text: this.formatNumber(taxAmount),
        fontSize: 9,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });

      summaryRows.push(vatRow);

      const grandTotalRow = [
        {
          text: "Grand Total / ยอดรวม",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 3,
        },
        { text: "" },
        { text: "" },
      ];

      if (this.showCurrencyColumn) {
        grandTotalRow.push({
          text: `${currency} ${this.formatNumber(grandTotalOth)}`,
          fontSize: 9,
          bold: true,
          alignment: "right",
          margin: [2, 3, 2, 3],
        });
      }

      grandTotalRow.push({
        text: this.formatNumber(grandTotal),
        fontSize: 9,
        bold: true,
        alignment: "right",
        margin: [2, 3, 2, 3],
      });

      summaryRows.push(grandTotalRow);

      return {
        table: {
          widths: summaryWidths,
          body: summaryRows,
        },
        layout: {
          hLineWidth: function(i, node) {
            return 1;
          },
          vLineWidth: function(i) {
            return 1;
          },
          hLineColor: function() {
            return "black";
          },
          vLineColor: function() {
            return "black";
          },
          paddingLeft: function() {
            return 0;
          },
          paddingRight: function() {
            return 0;
          },
          paddingTop: function() {
            return 0;
          },
          paddingBottom: function() {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createAmountInWords() {
      const amountText = this.dataToUse.textamount_total_en || "";

      // ตรวจสอบภาษาของ customer_name
      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      const isThaiCustomer = checker_th.test(this.header.customer_name || "");

      // กำหนดข้อความจำนวนเงินตัวอักษรตามภาษา
      let displayText = "";
      if (isThaiCustomer) {
        // ถ้าชื่อลูกค้าเป็นภาษาไทย → แสดงจำนวนเงินเป็นภาษาไทยโดยไม่มีวงเล็บและ currency
        displayText = `${amountText} `;
      } else {
        // ถ้าชื่อลูกค้าเป็นภาษาอังกฤษ → แสดงจำนวนเงินเป็นภาษาอังกฤษพร้อมวงเล็บและ currency
        displayText = `(${amountText}) ${this.currencyPrint || "USD"}`;
        displayText = displayText.replace("US", "USD");
        displayText = displayText.replace("USDD", "USD");
      }

      const widths = this.showCurrencyColumn
        ? [35, "*", 70, 80, 80]
        : [35, "*", 70, 80];

      const cells = [
        {
          text: displayText, // ← ใช้ displayText แทน
          fontSize: 9,
          alignment: "center",
          margin: [5, 8, 5, 8],
          fillColor: "#d8d8d8",
          colSpan: this.showCurrencyColumn ? 5 : 4,
        },
        {},
      ];

      const emptyCellCount = this.showCurrencyColumn ? 3 : 2;
      for (let i = 0; i < emptyCellCount; i++) {
        cells.push({});
      }

      return {
        table: {
          widths: widths,
          body: [cells],
        },
        layout: {
          hLineWidth: function() {
            return 0;
          },
          vLineWidth: function() {
            return 1;
          },
          hLineColor: function() {
            return "black";
          },
          vLineColor: function() {
            return "black";
          },
          paddingLeft: function() {
            return 0;
          },
          paddingRight: function() {
            return 0;
          },
          paddingTop: function() {
            return 0;
          },
          paddingBottom: function() {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createPaymentConditions() {
      const paymentBy = this.payment_by_print || "";
      const paymentDetail = this.dataToUse.print_header?.payment_detail || "";

      // กำหนด radio button ตามค่า payment_by_print
      const cashChecked = paymentBy === "Cash" || paymentBy === "cash";
      const transferChecked = paymentBy === "Transfer" || paymentBy === "Bank";
      const chequeChecked = paymentBy === "Cheque" || paymentBy === "cheque";

      return {
        table: {
          widths: ["*"],
          body: [
            [
              {
                stack: [
                  {
                    text: "Payment Conditions:",
                    fontSize: 9,
                    bold: true,
                    margin: [2, 5, 2, 3],
                  },
                  {
                    columns: [
                      {
                        width: "auto",
                        canvas: cashChecked
                          ? [
                              {
                                type: "ellipse",
                                x: 5,
                                y: 5,
                                r1: 4,
                                r2: 4,
                                lineColor: "black",
                              },
                              {
                                type: "ellipse",
                                x: 5,
                                y: 5,
                                r1: 2,
                                r2: 2,
                                color: "black",
                              },
                            ]
                          : [
                              {
                                type: "ellipse",
                                x: 5,
                                y: 5,
                                r1: 4,
                                r2: 4,
                                lineColor: "black",
                              },
                            ],
                        margin: [10, 0, 5, 0],
                      },
                      {
                        width: "auto",
                        text: "Cash/เงินสด",
                        fontSize: 9,
                        margin: [0, 0, 20, 0],
                      },
                      {
                        width: "auto",
                        canvas: transferChecked
                          ? [
                              {
                                type: "ellipse",
                                x: 5,
                                y: 5,
                                r1: 4,
                                r2: 4,
                                lineColor: "black",
                              },
                              {
                                type: "ellipse",
                                x: 5,
                                y: 5,
                                r1: 2,
                                r2: 2,
                                color: "black",
                              },
                            ]
                          : [
                              {
                                type: "ellipse",
                                x: 5,
                                y: 5,
                                r1: 4,
                                r2: 4,
                                lineColor: "black",
                              },
                            ],
                        margin: [0, 0, 5, 0],
                      },
                      {
                        width: "auto",
                        text: "Transfer/โอนเงิน",
                        fontSize: 9,
                        margin: [0, 0, 20, 0],
                      },
                      {
                        width: "auto",
                        canvas: chequeChecked
                          ? [
                              {
                                type: "ellipse",
                                x: 5,
                                y: 5,
                                r1: 4,
                                r2: 4,
                                lineColor: "black",
                              },
                              {
                                type: "ellipse",
                                x: 5,
                                y: 5,
                                r1: 2,
                                r2: 2,
                                color: "black",
                              },
                            ]
                          : [
                              {
                                type: "ellipse",
                                x: 5,
                                y: 5,
                                r1: 4,
                                r2: 4,
                                lineColor: "black",
                              },
                            ],
                        margin: [0, 0, 5, 0],
                      },
                      {
                        width: "auto",
                        text: "Cheque/เช็คธนาคาร",
                        fontSize: 9,
                        margin: [0, 0, 20, 0],
                      },
                      {
                        width: "auto",
                        text: "No./เลขที่ : " + this.bank_no_show,
                        fontSize: 9,
                      },
                    ],
                    margin: [2, 3, 2, 5],
                  },
                ],
                margin: [2, 0, 2, 0],
              },
            ],
            [
              {
                text: `Payment Details / รายละเอียด:${
                  paymentDetail ? "  " + paymentDetail : ""
                }`,
                fontSize: 9,
                margin: [2, 5, 2, 20],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: function(i, node) {
            if (i === 0 || i === node.table.body.length) {
              return 1;
            }
            return 0;
          },
          vLineWidth: function() {
            return 1;
          },
          hLineColor: function() {
            return "black";
          },
          vLineColor: function() {
            return "black";
          },
          paddingLeft: function() {
            return 0;
          },
          paddingRight: function() {
            return 0;
          },
          paddingTop: function() {
            return 0;
          },
          paddingBottom: function() {
            return 0;
          },
        },
        margin: [0, 0, 0, 15],
      };
    },

    createSignatureBox() {
      return {
        columns: [
          {
            width: "50%",
            text: "",
          },
          {
            width: "50%",
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    stack: [
                      {
                        text: "",
                        margin: [0, 0, 0, 35],
                      },
                      {
                        canvas: [
                          {
                            type: "line",
                            x1: 30,
                            y1: 0,
                            x2: 200,
                            y2: 0,
                            lineWidth: 1,
                          },
                        ],
                        margin: [0, 0, 0, 5],
                      },
                      {
                        text: "Authorized Signature / ผู้รับเงิน",
                        fontSize: 9,
                        alignment: "center",
                        margin: [0, 0, 0, 10],
                      },
                      {
                        text: "Date/วันที่ _______________________",
                        fontSize: 9,
                        alignment: "center",
                        margin: [0, 0, 0, 10],
                      },
                    ],
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function() {
                return 1;
              },
              vLineWidth: function() {
                return 1;
              },
              hLineColor: function() {
                return "black";
              },
              vLineColor: function() {
                return "black";
              },
            },
          },
        ],
        margin: [0, 0, 0, 15],
      };
    },

    createFooterNote() {
      return {
        stack: [
          {
            text:
              "This receipt will be valid whgn the company has received the payment into the bank account.",
            fontSize: 8,
            alignment: "center",
            margin: [0, 5, 0, 0],
          },
          {
            text:
              "ใบเสร็จรับเงินนี้จะสมบูรณ์เมื่อบริษัทได้รับชำระเงินเข้าในบัญชีธนาคารเรียบร้อยแล้ว",
            fontSize: 8,
            alignment: "center",
          },
        ],
        margin: [0, 10, 0, 0],
      };
    },

    generateMainReceipt() {
      const mainContent = [];
      mainContent.push(this.createHeader());
      mainContent.push(this.createTitle());
      mainContent.push(this.createCustomerInfo());
      mainContent.push(this.createItemsTable());
      mainContent.push(this.createSummaryTable());
      mainContent.push(this.createAmountInWords());
      mainContent.push(this.createPaymentConditions());
      mainContent.push(this.createSignatureBox());
      mainContent.push(this.createFooterNote());
      return mainContent;
    },

    generateDocDefinition() {
      const mainReceipt = this.generateMainReceipt();
      const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 40, 40, 40],
        content: mainReceipt,
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };
      return docDefinition;
    },

    async exportReceiptToPDFMake() {
      // สร้างข้อมูลแล้วโยนเข้า mockData
      // this.mockData.main_data = {
      //   datashowAll: this.datashowAll,
      //   print_header: this.print_header,
      //   heighttabledetail: this.heighttabledetail,
      //   currency_print: this.currency_print,
      //   check_cus_name: this.check_cus_name,
      //   textamount_total_en: this.textamount_total_en,
      //   checklawoffice: this.checklawoffice,
      //   exchange_rate: this.exchange_rate,
      //   branch_cus: this.branch_cus,
      //   payment_by_print: this.payment_by_print,
      //   bank_name_show: this.bank_name_show,
      //   bank_no_show: this.bank_no_show,
      // };

      const receiptData = {
        datashowAll: this.datashowAll,
        print_header: this.print_header,
        heighttabledetail: this.heighttabledetail,
        currency_print: this.currency_print,
        check_cus_name: this.check_cus_name,
        textamount_total_en: this.textamount_total_en,
        checklawoffice: this.checklawoffice,
        exchange_rate: this.exchange_rate,
        branch_cus: this.branch_cus,
        payment_by_print: this.payment_by_print,
        bank_name_show: this.bank_name_show,
        bank_no_show: this.bank_no_show,
      };

      // console.log(`Mock Data:`, JSON.stringify(this.mockData.main_data));

      // try {
      //   await this.waitForPdfMakeReady();
      // } catch (error) {
      //   console.error("❌ pdfMake ไม่พร้อมใช้งาน:", error);
      //   alert("ไม่สามารถโหลดระบบ PDF ได้ กรุณาลองใหม่อีกครั้ง");
      //   return;
      // }

      // try {
      //   const docDefinition = this.generateDocDefinition();
      //   pdfMake.createPdf(docDefinition).open();
      //   console.log("✅ สร้าง Receipt PDF สำเร็จ");
      // } catch (error) {
      //   console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
      //   alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      // }

      try {
        await generateReceiptPDF(receiptData);
      } catch (error) {
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },

    createItemsTableDetail() {
      const tableWidths = ["*", 70, 80]; // 3 คอลัมน์: Description, Quantity, Amount

      const headerRow = [
        {
          text: "Description / รายการ",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
        {
          text: "Quantity / จำนวน",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
        {
          text: "Amount / จำนวนเงิน",
          fontSize: 9,
          bold: true,
          alignment: "center",
          margin: [2, 3, 2, 3],
        },
      ];

      const bodyRows = [];
      const minRows = 7;

      const detailItems = this.print_table_Rcdetail || [];

      for (let i = 0; i < minRows; i++) {
        if (i < detailItems.length) {
          const item = detailItems[i];
          console.log(`Detail item ${i}:`, JSON.stringify(item));

          const row = [
            {
              text: item.description || "",
              fontSize: 9,
              margin: [2, 3, 2, 3],
            },
            {
              text: item.quantity ? this.formatNumber(item.quantity) : "",
              fontSize: 9,
              alignment: "center",
              margin: [2, 3, 2, 3],
            },
            {
              text: item.amount ? this.formatNumber(item.amount) : "",
              fontSize: 9,
              alignment: "right",
              margin: [2, 3, 2, 3],
            },
          ];

          bodyRows.push(row);
        } else {
          const emptyRow = [
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
            {
              text: "",
              fontSize: 9,
              margin: [2, 15, 2, 15],
            },
          ];
          bodyRows.push(emptyRow);
        }
      }

      return {
        table: {
          headerRows: 1,
          widths: tableWidths,
          body: [headerRow, ...bodyRows],
        },
        layout: {
          hLineWidth: function(i, node) {
            if (i === 0 || i === 1 || i === node.table.body.length) {
              return 1;
            }
            return 0;
          },
          vLineWidth: function(i) {
            return 1;
          },
          paddingLeft: function() {
            return 0;
          },
          paddingRight: function() {
            return 0;
          },
          paddingTop: function() {
            return 0;
          },
          paddingBottom: function() {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createHeaderDetail() {
      const header = this.print_detail_header || {}; // ใช้ print_detail_header แทน

      return {
        columns: [
          {
            width: "50%",
            stack: [
              {
                text: header.com_eng_1 || "DEJ-UDOM & ASSOCIATES LTD.",
                fontSize: 11,
                bold: true,
                margin: [0, 0, 0, 1],
              },
              {
                text: header.com_eng_2 || "ATTORNEY AT LAW",
                fontSize: 8,
                bold: true,
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  header.com_thai || "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                fontSize: 8,
                margin: [0, 0, 0, 1],
              },
            ],
          },
          {
            width: "50%",
            stack: [
              {
                text:
                  header.com_add_name ||
                  "CHARN ISSARA TOWER 2nd FLOOR, 942/69 RAMA IV ROAD,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  this.header.com_add_city ||
                  "KWAENG SURIYAWONG, KHET BANGRAK,",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: this.header.com_add_country || "BANGKOK 10500, THAILAND",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: header.com_add_tel || "Tel : 0-2233-0055, 0-2233-0068",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text: header.com_add_email || "E-MAIL : account@dejudom.com",
                fontSize: 7,
                alignment: "right",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  header.com_add_tax_id ||
                  'TAX ID. No. 0105534015348 / "HEAD OFFICE"',
                fontSize: 7,
                alignment: "right",
                bold: true,
              },
            ],
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    createTitleDetail() {
      const header = this.print_detail_header || {};

      return {
        stack: [
          {
            text: header.com_title || "RECEIPT / TAX INVOICE",
            fontSize: 14,
            bold: true,
            alignment: "center",
            margin: [0, 15, 0, 2],
          },
          {
            text: header.com_title_th || "ใบเสร็จรับเงิน / ใบกำกับภาษี",
            fontSize: 12,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 10],
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 0,
                x2: 515,
                y2: 0,
                lineWidth: 1,
              },
            ],
            margin: [0, 0, 0, 10],
          },
        ],
      };
    },

    createCustomerInfoDetail() {
      const header = this.print_detail_header || {};
      const addressLines = (header.addressall || "").split("\n");
      const filteredAddress = addressLines
        .filter((line) => line.trim() !== "" && line.trim() !== ",")
        .join(", ");

      const rightColumnStack = [
        {
          text: `No. / เลขที่ : ${header.inv_id || "________"}`,
          fontSize: 9,
          alignment: "right",
          margin: [0, 0, 0, 5],
        },
        {
          text: `Date / วันที่ : ${this.formatDate(header.invoice_date) ||
            "______________"}`,
          fontSize: 9,
          alignment: "right",
          margin: [0, 0, 0, 5],
        },
      ];

      if (this.currency_print !== "THB") {
        rightColumnStack.push({
          text: `Exchange Rate : ${this.exchange_rate || "______________"}`,
          fontSize: 9,
          alignment: "right",
        });
      }

      return {
        columns: [
          {
            width: "70%",
            stack: [
              {
                columns: [
                  {
                    width: 60,
                    text: "To / ถึง:",
                    fontSize: 9,
                  },
                  {
                    width: "*",
                    text: header.customer_name || "Customer Name",
                    fontSize: 9,
                    bold: true,
                  },
                ],
                margin: [0, 0, 0, 3],
              },
              {
                columns: [
                  {
                    width: 60,
                    text: "",
                    fontSize: 8,
                  },
                  {
                    width: "*",
                    text: filteredAddress || "Address",
                    fontSize: 8,
                  },
                ],
                margin: [0, 0, 0, 3],
              },
              {
                columns: [
                  {
                    width: 60,
                    text: "Tax ID:",
                    fontSize: 9,
                  },
                  {
                    width: "*",
                    text: `${header.customer_taxid || "__________________"} ${header.customer_branch?` / ${header.customer_branch}`:''}`,
                    fontSize: 9,
                  },
                ],
              },
            ],
          },
          {
            width: "30%",
            stack: rightColumnStack,
          },
        ],
        margin: [0, 0, 0, 10],
      };
    },

    createSummaryTableDetail() {
      const header = this.print_detail_header || {};
      const subTotal = header.sub_total || 0;
      const taxRate = header.tax_rate || "7.00";
      const taxAmount = header.tax_rate_amount || 0;
      const grandTotal = header.amount_total || 0;

      const summaryWidths = ["*", 70, 80]; // เปลี่ยนเป็น 3 คอลัมน์

      const summaryRows = [];

      const subTotalRow = [
        {
          text: "Sub Total / รวมเป็นเงิน",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 2, // เปลี่ยนจาก 3 เป็น 2
        },
        { text: "" },
        {
          text: this.formatNumber(subTotal),
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        },
      ];

      summaryRows.push(subTotalRow);

      const vatRow = [
        {
          text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${taxRate} %)`,
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 2, // เปลี่ยนจาก 3 เป็น 2
        },
        { text: "" },
        {
          text: this.formatNumber(taxAmount),
          fontSize: 9,
          alignment: "right",
          margin: [2, 3, 2, 3],
        },
      ];

      summaryRows.push(vatRow);

      const grandTotalRow = [
        {
          text: "Grand Total / ยอดรวม",
          fontSize: 9,
          bold: true,
          alignment: "left",
          margin: [2, 3, 2, 3],
          colSpan: 2, // เปลี่ยนจาก 3 เป็น 2
        },
        { text: "" },
        {
          text: this.formatNumber(grandTotal),
          fontSize: 9,
          bold: true,
          alignment: "right",
          margin: [2, 3, 2, 3],
        },
      ];

      summaryRows.push(grandTotalRow);

      return {
        table: {
          widths: summaryWidths,
          body: summaryRows,
        },
        layout: {
          hLineWidth: function(i, node) {
            return 1;
          },
          vLineWidth: function(i) {
            return 1;
          },
          hLineColor: function() {
            return "black";
          },
          vLineColor: function() {
            return "black";
          },
          paddingLeft: function() {
            return 0;
          },
          paddingRight: function() {
            return 0;
          },
          paddingTop: function() {
            return 0;
          },
          paddingBottom: function() {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    createAmountInWordsDetail() {
      const amountText = this.textamount_total_en || "";
      const header = this.print_detail_header || {};

      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      const isThaiCustomer = checker_th.test(header.customer_name || "");

      let displayText = "";
      if (isThaiCustomer) {
        displayText = `${amountText}`;
      } else {
        displayText = `(${amountText}) ${this.currencyPrint || "USD"}`;
        displayText = displayText.replace("US", "USD");
        displayText = displayText.replace("USDD", "USD");
      }

      const widths = ["*", 70, 80]; // เปลี่ยนเป็น 3 คอลัมน์

      const cells = [
        {
          text: displayText,
          fontSize: 9,
          alignment: "center",
          margin: [5, 8, 5, 8],
          fillColor: "#d8d8d8",
          colSpan: 3, // เปลี่ยนจาก 4 เป็น 3
        },
        {},
        {},
      ];

      return {
        table: {
          widths: widths,
          body: [cells],
        },
        layout: {
          hLineWidth: function() {
            return 0;
          },
          vLineWidth: function() {
            return 1;
          },
          hLineColor: function() {
            return "black";
          },
          vLineColor: function() {
            return "black";
          },
          paddingLeft: function() {
            return 0;
          },
          paddingRight: function() {
            return 0;
          },
          paddingTop: function() {
            return 0;
          },
          paddingBottom: function() {
            return 0;
          },
        },
        margin: [0, 0, 0, 0],
      };
    },

    // 3. สร้างฟังก์ชัน generateMainReceiptDetail()
    generateMainReceiptDetail() {
      const mainContent = [];
      mainContent.push(this.createHeaderDetail());
      mainContent.push(this.createTitleDetail());
      mainContent.push(this.createCustomerInfoDetail());
      mainContent.push(this.createItemsTableDetail());
      mainContent.push(this.createSummaryTableDetail());
      mainContent.push(this.createAmountInWordsDetail());
      mainContent.push(this.createPaymentConditions());
      mainContent.push(this.createSignatureBox());
      mainContent.push(this.createFooterNote());
      return mainContent;
    },

    // 4. สร้างฟังก์ชัน generateDocDefinitionDetail()
    generateDocDefinitionDetail() {
      const mainReceiptDetail = this.generateMainReceiptDetail();
      const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 40, 40, 40],
        content: mainReceiptDetail,
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };
      return docDefinition;
    },

    // 5. สร้างฟังก์ชันหลัก exportReceiptDetailToPDFMake()
    async exportReceiptDetailToPDFMake() {
      // สร้างข้อมูลแล้วโยนเข้า mockData
      this.mockData.main_data_detail = {
        datashowAllDetail: this.datashowAllDetail,
        print_header: this.print_detail_header,
        heighttabledetail: this.heighttabledetail,
        currency_print: this.currency_print,
        check_cus_name: this.check_cus_name,
        textamount_total_en: this.textamount_total_en,
        checklawoffice: this.checklawoffice,
        exchange_rate: this.exchange_rate,
        branch_cus: this.branch_cus,
        payment_by_print: this.payment_by_print,
        bank_name_show: this.bank_name_show,
        bank_no_show: this.bank_no_show,
        currency_show: this.currency_show,
      };

      // console.log(
      //   `Mock Data Detail:`,
      //   JSON.stringify(this.mockData.main_data_detail),
      // );

      const receiptDetailData = {
        datashowAllDetail: this.datashowAllDetail,
        print_header: this.print_detail_header,
        heighttabledetail: this.heighttabledetail,
        currency_print: this.currency_print,
        check_cus_name: this.check_cus_name,
        textamount_total_en: this.textamount_total_en,
        checklawoffice: this.checklawoffice,
        exchange_rate: this.exchange_rate,
        branch_cus: this.branch_cus,
        payment_by_print: this.payment_by_print,
        bank_name_show: this.bank_name_show,
        bank_no_show: this.bank_no_show,
        currency_show: this.currency_show,
      };

      // try {
      //   await this.waitForPdfMakeReady();
      // } catch (error) {
      //   console.error("❌ pdfMake ไม่พร้อมใช้งาน:", error);
      //   alert("ไม่สามารถโหลดระบบ PDF ได้ กรุณาลองใหม่อีกครั้ง");
      //   return;
      // }

      // try {
      //   const docDefinition = this.generateDocDefinitionDetail();
      //   pdfMake.createPdf(docDefinition).open();
      //   console.log("✅ สร้าง Receipt Detail PDF สำเร็จ");
      // } catch (error) {
      //   console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
      //   alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      // }

      try {
        // เปิดใน tab ใหม่
        await generateReceiptDetailPDF(receiptDetailData);

        // หรือดาวน์โหลดไฟล์
        // await downloadReceiptDetailPDF(receiptDetailData, 'receipt-detail-001.pdf');

        // หรือพิมพ์โดยตรง
        // await printReceiptDetailPDF(receiptDetailData);
      } catch (error) {
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },
  },
};
